import { render, staticRenderFns } from "./MetadadosCampoDinamicoTextoTooltip.vue?vue&type=template&id=20236899"
import script from "./MetadadosCampoDinamicoTextoTooltip.vue?vue&type=script&lang=js"
export * from "./MetadadosCampoDinamicoTextoTooltip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports